<template>
  <div v-if="isStrategies" class="h-full">
    <PositionTableTabToggle v-model:position-order-type="selectedTab" />

    <PositionsTable
      v-if="selectedTab === OPTION_POSITION_ORDER_TYPES.positions.value"
    />

    <StrategiesTable v-else />
  </div>

  <PositionsTable v-else />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useFeatureFlag } from '@libs/feature-flag';

import {
  OPTION_POSITION_ORDER_TYPES,
  PositionTableTabToggle,
  PositionsTable,
  StrategiesTable,
} from '@/modules/option';

const isStrategies = useFeatureFlag('strategies');
const selectedTab = ref(OPTION_POSITION_ORDER_TYPES.positions.value);
</script>
